"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateQuantity = exports.getEditableQuantityProps = exports.viewProduct = exports.removeProduct = exports.addProduct = void 0;
const constants_1 = require("../constants");
const getActionableProps = ({ product, session }) => ({
    [constants_1.EventProperty.ACTION_SCREEN]: product.screen,
    [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
    [constants_1.EventProperty.ORDER_NOTE]: product.note,
    [constants_1.EventProperty.PRODUCT_CATEGORY]: product.category,
    [constants_1.EventProperty.PRODUCT_ID]: product.id,
    [constants_1.EventProperty.PRODUCT_NAME]: product.name,
    [constants_1.EventProperty.PRODUCT_PRICE]: product.price,
    [constants_1.EventProperty.PRODUCT_SKU]: product.sku,
    [constants_1.EventProperty.USER_ID]: session.userID,
    [constants_1.EventProperty.SESSION_ID]: session.sessionID
});
exports.addProduct = ({ product, session }) => {
    const props = getActionableProps({ product, session });
    window.analytics.track(constants_1.EventName.PRODUCT_ADDED, props);
};
exports.removeProduct = ({ product, session, }) => {
    const props = getActionableProps({ product, session });
    window.analytics.track(constants_1.EventName.PRODUCT_REMOVED, props);
};
const getViewableProps = ({ product, session }) => {
    const { [constants_1.EventProperty.ORDER_NOTE]: note, ...viewableProps } = getActionableProps({
        product: { ...product, note: '' },
        session,
    });
    return viewableProps;
};
exports.viewProduct = ({ product, session }) => {
    const props = getViewableProps({ product, session });
    window.analytics.track(constants_1.EventName.PRODUCT_VIEWED, props);
};
exports.getEditableQuantityProps = ({ product, session }) => {
    const actionableProps = getActionableProps({
        product,
        session,
    });
    return {
        ...actionableProps,
        [constants_1.EventProperty.PRODUCT_NEW_QUANTITY]: product.quantity
    };
};
exports.updateQuantity = ({ product, session }) => {
    const props = exports.getEditableQuantityProps({ product, session });
    window.analytics.track(constants_1.EventName.PRODUCT_QUANTITY_CHANGED, props);
};
